import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

const Protected = ({ protect, children, requiredRole }) => {
  const navigate = useNavigate();
  let userToken = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!userToken) return;

    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        navigate("/logout");
      }, 1800000); // 30 minute (1800000 ms)
    };

    // Reset the timer on user activity
    const activityEvents = ["mousemove", "keydown", "scroll", "click"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    // Start initial timer
    resetTimer();

    return () => {
      clearTimeout(timer);
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [userToken, navigate]);

  if (
    protect &&
    requiredRole &&
    userToken?.result?.user?.role?.name !== requiredRole
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (protect) {
    if (!userToken) {
      return <Navigate to="/login" replace />;
    }
  } else if (userToken) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default Protected;
